import api from './api'
import Vue from 'vue'
import authUtils from '@/services/auth/utils'
import { noLoadingUrlList } from '@/config'
import store from '../store'
import router from '@/router'
// service 基础类，只用于继承
class Base {
  /**
   * Get请求
   * @param { String } url
   * @param { Object } params
   * @param { Boolean } mute 是否loading，默认false
   */
  sendGet (url, params, mute = false) {
    // 根据业务决定是否不显示loading
    !mute && (noLoadingUrlList.indexOf(url) === -1) && Vue.loading.on()
    return api
      .get(url, { params })
      .then(response => {
        Vue.loading.off()
        if (response.data.status_code === 401) {
          Vue.toast.danger('登录过期，请重新登录')
          router.push('/stu/stulogin')
          return
        }
        return response.data
      })
      .catch(() => {
        Vue.loading.off()
        console.log('get error')
      })
  }

  /**
   * Post 请求
   * @param { String } url
   * @param { Object} data
   */
  sendPost (url, data, mute = false, headers) {
    !mute && (noLoadingUrlList.indexOf(url) === -1) && Vue.loading.on()
    return api
      .post(url, data, {
        headers: headers || {}
      })
      .then(response => {
        Vue.loading.off()
        if (response.data.status_code === 401) {
          Vue.toast.danger('登录过期，请重新登录')
          router.push('/stu/stulogin')
          return
        } else if (response.data.status_code === 400) {
          Vue.toast.danger(response.data.message)
          return
        }
        return response.data
      })
      .catch(() => {
        Vue.loading.off()
        console.log('post error')
      })
  }

  /**
   * service 中处理错误信息，一般在 新增，修改，删除等操作中调用
   * @param { res.data } data response 中的data
   * @param { success | error | errorOnly } options 成功或失败的 msg, errorOnly 只提示错误消息
   */
  handleError (data, options = {}) {
    if (data.ok) {
      !options.errorOnly && Vue.toast.success(options.success || '操作成功')
    } else {
      Vue.toast.danger(options.error || data.message || '操作失败')
    }
  }

  /**
   * url替换工具方法
   * /test/{name} => /test/savo
   * @param { String } url 传入的 url 地址
   * @param { Object } params 要替换的参数
   */
  parseUrl (url, params) {
    Object.keys(params).forEach(key => {
      var reg = new RegExp('\\{' + key + '\\}')
      url = url.replace(reg, params[key])
    })
    return url
  }

  /**
   * Service 层面注入钉钉id, 在登录后的接口发送之前调用
   * @param { Object } params
   * @param { String } key 注入到 params 中的键
   */
  injectId (params, key = 'teacher_id') {
    params[key] = store.getters.loggedUserId
  }

  // 获取token
  getToken () {
    return authUtils.getToken()
  }

  /**
   * 生成get的url
   * @param { String } url
   * @param { Object } params
   */
  buildUrl (url, params) {
    let query = '?'
    for (var i in params) {
      query += i + '='
      query += params[i] + '&'
    }
    return url + query.slice(0, -1)
  }
}

export default Base
